import React from 'react';

const Filter = ({ onSetFilters, filters, onShowFilters }) => {

	const toggleFilterUI = (event) => {

		if (event.currentTarget.checked) {

			event.currentTarget.parentNode.classList.add('active');
		} else {

			event.currentTarget.parentNode.classList.remove('active');
		}
	};

	const checkParentToggle = ((event) => {

		const toggles = event.currentTarget.parentNode.querySelectorAll('input[type=checkbox]');
		let tickParentToggle = true;
		for (const toggle of toggles) {

			if ( !toggle.checked ) {

				tickParentToggle = false;
				break;
			}
		}

		const parentToggle = event.currentTarget.parentNode.parentNode.querySelector('.toggle-parent input[type=checkbox]');
		parentToggle.checked = tickParentToggle;
	})

	const checkChildToggles = (event) => {

		const toggles = event.currentTarget.parentNode.parentNode.parentNode.querySelectorAll('.toggles input[type=checkbox]');
		for (const toggle of toggles) {

			toggle.checked = event.currentTarget.checked;
		}		
	}

	const rarityFilters = ['1','2','3','4'];
	const rarityFilterUIs = rarityFilters.map(filterValue => {

		const name = 'rarity-' + filterValue.toLowerCase();
		const label = filterValue + '-Star';
		return 	<label key={name} className='pv1 flex flex-column items-center active'>
					<input type='checkbox' name={name} data-filtervalue={filterValue} className='mb1' onChange={toggleFilterUI} /> {label}
				</label>
	});

	const partPrimitiveFilters = ['Head','Chest','Arms','Legs','Backpack','Shield'];
	const partPrimitiveFilterUIs = partPrimitiveFilters.map(filterValue => {

		const name = 'part-' + filterValue.toLowerCase();
		return 	<label key={name} className='w-33 pv1 flex flex-column items-center active'>
					<input type='checkbox' name={name} data-filtervalue={filterValue} className='mb1' onChange={toggleFilterUI} /> {filterValue}
				</label>
	});

	const partMeleeWeaponFilters = ['Axe','Saber','Fist Module','Claw Module','Blade','Lance','Dual Saber','Twin Blade'];
	const partMeleeWeaponFilterUIs = partMeleeWeaponFilters.map(filterValue => {

		const name = 'part-weapon-' + filterValue.replace(/\s/g,'').toLowerCase();
		return 	<label key={name} className='w-33 pv1 flex flex-column items-center tc active' onClick={(event) => checkParentToggle(event)}>
					<input type='checkbox' name={name} data-filtervalue={filterValue} className='mb1' onChange={toggleFilterUI} /> {filterValue}
				</label>
	});

	const partRangedWeaponFilters = ['Rifle','Machinegun','Long Rifle','Gatling Gun','Bazooka','Whip'];
	const partRangedWeaponFilterUIs = partRangedWeaponFilters.map(filterValue => {

		const name = 'part-weapon-' + filterValue.replace(/\s/g,'').toLowerCase();
		return 	<label key={name} className='w-33 pv1 flex flex-column items-center active' onClick={(event) => checkParentToggle(event)}>
					<input type='checkbox' name={name} data-filtervalue={filterValue} className='mb1' onChange={toggleFilterUI} /> {filterValue}
				</label>
	});	

	const pilotFilters = ['All Rounder','Defender','In-Fighter','Out-Fighter','Middle-Shooter','Long-Shooter','Supporter'];
	const pilotFilterUIs = pilotFilters.map(filterValue => {

		const name = 'part-pilot-' + filterValue.replace(/[-\s]/g,'').toLowerCase();
		return 	<label key={name} className='w-33 pv1 flex flex-column items-center active' onClick={(event) => checkParentToggle(event)}>
					<input type='checkbox' name={name} data-filtervalue={filterValue} className='mb1' onChange={toggleFilterUI} /> {filterValue}
				</label>
	});

	return (
		<div className="filters">
			<h2
				className='pointer ttu ma0 f5 pv1 filters-header flex items-center ph2 pv0 justify-center hover-brand-magenta'
				onClick={() => onShowFilters(filters)}>Filters
			</h2>
			<div className='filters-body ph2 pt2 bg-white w-100'>
				<fieldset className='ph2 pt2 br-0 bb-0 bl-0 bt mt2'>
					<legend className='f6 ph2 tc b'>Rarity</legend>
					<div className='flex f7 justify-around filter-rarity'>{rarityFilterUIs}</div>
				</fieldset>
				<fieldset className='parts-filter ph2 pt2 br-0 bb-0 bl-0 bt mt2'>
					<legend className='f6 ph2 tc b'>Parts</legend>
					<div className='f7 filter-part'>
						<div className='flex flex-wrap justify-start'>{partPrimitiveFilterUIs}</div>
						<div className='pv1'>
							<fieldset className='ph0 pv2 br-0 bb-0 bl-0 bt mt2 melee-weapons'>
								<legend className='ph1 b'>
									<label className='toggle-parent'>
										<input
											defaultChecked 
											type='checkbox' 
											name='part-melee-weapons' 
											className='part-weapons mr1' 
											onClick={(event) => checkChildToggles(event)} /> Melee Weapons
									</label>
								</legend>
								<div className='flex flex-wrap justify-start toggles'>{partMeleeWeaponFilterUIs}</div>
							</fieldset>
							<fieldset className='ph0 pv2 br-0 bb-0 bl-0 bt mt2 ranged-weapons'>
								<legend className='ph1 b'>
									<label className='toggle-parent'>
										<input 
											defaultChecked
											type='checkbox' 
											name='part-melee-weapons' 
											className='part-weapons mr1' 
											onClick={(event) => checkChildToggles(event)} /> Ranged Weapons
									</label>
								</legend>
								<div className='flex flex-wrap justify-start toggles'>{partRangedWeaponFilterUIs}</div>
							</fieldset>
						</div>
						<div className='pv1'>
							<fieldset className='ph0 pv2 br-0 bb-0 bl-0 bt mt2 pilots'>
								<legend className='ph1 b'>
									<label className='toggle-parent'>
										<input 
											defaultChecked
											type='checkbox' 
											name='part-pilots' 
											className='part-pilots mr1' 
											onClick={(event) => checkChildToggles(event)} /> Pilots
									</label>
								</legend>
								<div className='flex flex-wrap justify-start toggles'>{pilotFilterUIs}</div>	
							</fieldset>					
						</div>
					</div>
				</fieldset>
				<div className='bg-white tr db f6 filters-footer shadow-1 flex justify-center'>
					<button
						className='ma1 ph2 pointer w-50 bg-brand-magenta white b bn'
						onClick={onSetFilters}>Set Filters</button>
					<button
						className='ma1 ph2 pointer w-50 bg-brand-magenta white b bn'
						onClick={() => document.querySelector('.filters-body').style.display = "none" }>Cancel</button>
				</div>
			</div>
		</div>
		)
}

export default Filter;